/**
 * CareStart wording for fusionmsi.com/splashpage only.
 * Other FusionMSI marketing routes keep their existing copy.
 */

export const CARESTART_SPLASH_WORDMARK = 'CareStart';
export const CARESTART_SPLASH_TAGLINE = 'Powered by Medical SuperIntelligence(TM)';

// The live FusionMSI tagline no longer ends with this suffix. Keep the strip so
// a leftover " / Accelerating Better Healthcare" cannot appear on /splashpage.
const ACCELERATING_TAGLINE = /\s*\/\s*Accelerating Better Healthcare/gi;

export function isCareStartSplashPath(pathname = '') {
  if (typeof pathname !== 'string') return false;
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return normalized === '/splashpage';
}

/**
 * Rewrite splash-page brand strings in place.
 * The long name is replaced before the short name so the tagline and footer
 * stay readable after both substitutions.
 */
export function withCareStartSplashCopy(text) {
  if (typeof text !== 'string' || !text) return text;
  const next = text
    .replaceAll('Fusion Medical SuperIntelligence', CARESTART_SPLASH_TAGLINE)
    .replaceAll('FusionMSI', CARESTART_SPLASH_WORDMARK)
    .replace(ACCELERATING_TAGLINE, '')
    .replace(
      `${CARESTART_SPLASH_TAGLINE} (${CARESTART_SPLASH_WORDMARK})`,
      `${CARESTART_SPLASH_WORDMARK}, ${CARESTART_SPLASH_TAGLINE},`,
    );
  return next.replace(/[ \t]{2,}/g, ' ').trim();
}

export function careStartSplashGate(gate) {
  return {
    ...gate,
    wordmark: withCareStartSplashCopy(gate.wordmark),
    tagline: withCareStartSplashCopy(gate.tagline),
    prompt: withCareStartSplashCopy(gate.prompt),
    footnote: withCareStartSplashCopy(gate.footnote),
    cards: gate.cards.map((card) => ({
      ...card,
      title: withCareStartSplashCopy(card.title),
      desc: withCareStartSplashCopy(card.desc),
      cta: withCareStartSplashCopy(card.cta),
    })),
    caremap: {
      ...gate.caremap,
      eyebrow: withCareStartSplashCopy(gate.caremap.eyebrow),
      title: withCareStartSplashCopy(gate.caremap.title),
      desc: withCareStartSplashCopy(gate.caremap.desc),
      cta: withCareStartSplashCopy(gate.caremap.cta),
    },
    voxpont: {
      ...gate.voxpont,
      eyebrow: withCareStartSplashCopy(gate.voxpont.eyebrow),
      title: withCareStartSplashCopy(gate.voxpont.title),
      desc: withCareStartSplashCopy(gate.voxpont.desc),
      cta: withCareStartSplashCopy(gate.voxpont.cta),
    },
  };
}
